import React, { useRef, useEffect, useState, useCallback } from "react";
import { createPortal } from "react-dom";
import wowcarzLogo from '../../assets/logowhite.png';
import carMovingGif from '../../assets/car_moving.gif';

const DUMMY_AVATAR = (seed) =>
  `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(seed)}`;

const FOUNDERS = [
  { id: "f1", name: "Arjun Mehta", role: "CEO & Co-Founder", avatar: DUMMY_AVATAR("arjun-ceo") },
  { id: "f2", name: "Rhea Kapoor", role: "COO & Co-Founder", avatar: DUMMY_AVATAR("rhea-coo") },
];

const DEPARTMENTS = [
  {
    id: "it",
    name: "IT",
    color: "#3B82F6",
    description: "Architects and maintains core technical infrastructure, cloud services, deployment pipelines, and platform reliability.",
    lead: { name: "Praveen Kumar", role: "Head of IT", avatar: DUMMY_AVATAR("it-lead"), email: "praveen.k@wowcarz.com", experience: "8+ yrs" },
    members: [
      { name: "Sneha Patel", role: "DevOps Engineer", avatar: DUMMY_AVATAR("it-1"), email: "sneha.p@wowcarz.com", experience: "4 yrs" },
      { name: "Rahul Nair", role: "Frontend Engineer", avatar: DUMMY_AVATAR("it-2"), email: "rahul.n@wowcarz.com", experience: "3 yrs" },
      { name: "Divya Sharma", role: "QA Engineer", avatar: DUMMY_AVATAR("it-3"), email: "divya.s@wowcarz.com", experience: "2.5 yrs" },
    ],
  },
  {
    id: "sales",
    name: "Sales",
    color: "#10B981",
    description: "Drives customer acquisition, fleet host partnerships, enterprise client pipelines, and revenue expansion.",
    lead: { name: "Hema Sales", role: "Sales Lead", avatar: DUMMY_AVATAR("sales-lead"), email: "hema.s@wowcarz.com", experience: "6+ yrs" },
    members: [
      { name: "Anusha S", role: "Sales Executive", avatar: DUMMY_AVATAR("sales-1"), email: "anusha.s@wowcarz.com", experience: "2 yrs" },
      { name: "Vidhya C", role: "Sales Executive", avatar: DUMMY_AVATAR("sales-2"), email: "vidhya.c@wowcarz.com", experience: "1.5 yrs" },
    ],
  },
  {
    id: "support",
    name: "Support",
    color: "#F59E0B",
    description: "Delivers round-the-clock roadside and booking assistance, conflict resolution, and customer satisfaction monitoring.",
    lead: { name: "Subasri R", role: "Support Lead", avatar: DUMMY_AVATAR("support-lead"), email: "subasri.r@wowcarz.com", experience: "5 yrs" },
    members: [
      { name: "Muneer Basha", role: "Support Agent", avatar: DUMMY_AVATAR("support-1"), email: "muneer.b@wowcarz.com", experience: "2 yrs" },
      { name: "Rizwana Begum", role: "Support Agent", avatar: DUMMY_AVATAR("support-2"), email: "rizwana.b@wowcarz.com", experience: "2 yrs" },
    ],
  },
  {
    id: "admin",
    name: "Admin",
    color: "#8B5CF6",
    description: "Oversees company logistics, office operations, legal documentation compliance, and internal employee facilitation.",
    lead: { name: "Victoria", role: "Admin Head", avatar: DUMMY_AVATAR("admin-lead"), email: "victoria@wowcarz.com", experience: "7 yrs" },
    members: [
      { name: "Harshia Bhanu", role: "Admin Executive", avatar: DUMMY_AVATAR("admin-1"), email: "harshia.b@wowcarz.com", experience: "3 yrs" },
    ],
  },
  {
    id: "backend",
    name: "Backend",
    color: "#EC4899",
    description: "Designs distributed APIs, high-throughput reservation logic, payment webhooks, and database architectures.",
    lead: { name: "Dhyan", role: "Backend Lead", avatar: DUMMY_AVATAR("backend-lead"), email: "dhyan@wowcarz.com", experience: "6 yrs" },
    members: [
      { name: "Santhosh S", role: "Backend Engineer", avatar: DUMMY_AVATAR("backend-1"), email: "santhosh.s@wowcarz.com", experience: "3 yrs" },
      { name: "Madesh M", role: "Backend Engineer", avatar: DUMMY_AVATAR("backend-2"), email: "madesh.m@wowcarz.com", experience: "2 yrs" },
    ],
  },
  {
    id: "fleet",
    name: "Fleet",
    color: "#14B8A6",
    description: "Manages vehicle telemetry, periodic servicing schedules, inventory health checks, and host onboarding logistics.",
    lead: { name: "Sharaths S", role: "Fleet Manager", avatar: DUMMY_AVATAR("fleet-lead"), email: "sharaths.s@wowcarz.com", experience: "7 yrs" },
    members: [
      { name: "Saravanan", role: "Fleet Coordinator", avatar: DUMMY_AVATAR("fleet-1"), email: "saravanan@wowcarz.com", experience: "2.5 yrs" },
      { name: "Vinoth", role: "Fleet Coordinator", avatar: DUMMY_AVATAR("fleet-2"), email: "vinoth@wowcarz.com", experience: "1.5 yrs" },
    ],
  },
  {
    id: "management",
    name: "Management",
    color: "#EF4444",
    description: "Coordinates cross-department operations, strategic expansion initiatives, and key company-wide OKRs.",
    lead: { name: "Rehan Nousheen", role: "Ops Manager", avatar: DUMMY_AVATAR("mgmt-lead"), email: "rehan.n@wowcarz.com", experience: "9 yrs" },
    members: [
      { name: "Manohar M", role: "Operations Associate", avatar: DUMMY_AVATAR("mgmt-1"), email: "manohar.m@wowcarz.com", experience: "2 yrs" },
    ],
  },
  {
    id: "accounts",
    name: "Accounts",
    color: "#6366F1",
    description: "Handles financial accounting, audit trail validation, host payout distributions, and taxation filings.",
    lead: { name: "Venkata Vani", role: "Accounts Head", avatar: DUMMY_AVATAR("accounts-lead"), email: "venkata.v@wowcarz.com", experience: "10 yrs" },
    members: [
      { name: "Sridhar K", role: "Accountant", avatar: DUMMY_AVATAR("accounts-1"), email: "sridhar.k@wowcarz.com", experience: "4 yrs" },
    ],
  },
];

const DEFAULT_POSITIONS = {
  it: { x: 40, y: 320 },
  sales: { x: 340, y: 320 },
  support: { x: 640, y: 320 },
  admin: { x: 940, y: 320 },
  backend: { x: 40, y: 580 },
  fleet: { x: 340, y: 580 },
  management: { x: 640, y: 580 },
  accounts: { x: 940, y: 580 },
};

export default function OrgStructure({ theme = "light" }) {
  const tokens = {
    light: { bgCanvas: "#F8FAFC", bgSurface: "#FFFFFF", border: "#E2E8F0", textHi: "#0F172A", textMid: "#475569", dot: "15,23,42" },
    dark: { bgCanvas: "#0B0F19", bgSurface: "#111827", border: "#374151", textHi: "#F9FAFB", textMid: "#9CA3AF", dot: "255,255,255" },
  }[theme];

  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const mouseRef = useRef({ x: -9999, y: -9999 });
  const dotsRef = useRef([]);
  const rafRef = useRef(null);

  const [positions, setPositions] = useState(DEFAULT_POSITIONS);
  const dragState = useRef(null);

  const [hoveredMember, setHoveredMember] = useState(null);
  const [modalMember, setModalMember] = useState(null);
  const [selectedDept, setSelectedDept] = useState(null);

  // ---------- Steering wheel → pan control ----------
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const [wheelAngle, setWheelAngle] = useState(0);
  const wheelDragRef = useRef(null);
  const panRafRef = useRef(null);
  const wheelAngleRef = useRef(0);

  useEffect(() => {
    wheelAngleRef.current = wheelAngle;
  }, [wheelAngle]);

  useEffect(() => {
    const MAX_SPEED = 6;
    const DEAD_ZONE = 4;

    const tick = () => {
      const angle = wheelAngleRef.current;
      if (Math.abs(angle) > DEAD_ZONE) {
        const normalized = Math.max(-1, Math.min(1, angle / 90));
        setPan((prev) => ({
          x: prev.x - normalized * MAX_SPEED,
          y: prev.y,
        }));
      }
      panRafRef.current = requestAnimationFrame(tick);
    };
    panRafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(panRafRef.current);
  }, []);

  const handleWheelMouseDown = useCallback((e) => {
    const wheelEl = e.currentTarget;
    const rect = wheelEl.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const startAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX) * (180 / Math.PI);
    wheelDragRef.current = { centerX, centerY, startAngle, startWheelAngle: wheelAngle };

    const onMove = (ev) => {
      if (!wheelDragRef.current) return;
      const { centerX, centerY, startAngle, startWheelAngle } = wheelDragRef.current;
      const currentAngle = Math.atan2(ev.clientY - centerY, ev.clientX - centerX) * (180 / Math.PI);
      let delta = currentAngle - startAngle;
      let next = startWheelAngle + delta;
      next = Math.max(-180, Math.min(180, next));
      setWheelAngle(next);
    };
    const onUp = () => {
      wheelDragRef.current = null;
      const interval = setInterval(() => {
        setWheelAngle((prev) => {
          if (Math.abs(prev) < 1) {
            clearInterval(interval);
            return 0;
          }
          return prev * 0.88;
        });
      }, 16);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  }, [wheelAngle]);

  // ---------- Floating dot background ----------
  useEffect(() => {
    const canvas = canvasRef.current;
    const container = containerRef.current;
    if (!canvas || !container) return;
    const ctx = canvas.getContext("2d");

    const resize = () => {
      canvas.width = container.offsetWidth;
      canvas.height = container.offsetHeight;
      const count = Math.floor((canvas.width * canvas.height) / 9000);
      dotsRef.current = Array.from({ length: count }).map(() => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.25,
        vy: (Math.random() - 0.5) * 0.25,
        baseR: 1 + Math.random() * 1.2,
      }));
    };
    resize();
    window.addEventListener("resize", resize);

    const handleMove = (e) => {
      const rect = container.getBoundingClientRect();
      mouseRef.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
    };
    const handleLeave = () => {
      mouseRef.current = { x: -9999, y: -9999 };
    };
    container.addEventListener("mousemove", handleMove);
    container.addEventListener("mouseleave", handleLeave);

    const PROXIMITY = 140;

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const { x: mx, y: my } = mouseRef.current;
      const dots = dotsRef.current;

      for (let i = 0; i < dots.length; i++) {
        const d = dots[i];
        d.x += d.vx;
        d.y += d.vy;
        if (d.x < 0 || d.x > canvas.width) d.vx *= -1;
        if (d.y < 0 || d.y > canvas.height) d.vy *= -1;

        const dist = Math.hypot(d.x - mx, d.y - my);
        const proximity = Math.max(0, 1 - dist / PROXIMITY);
        const r = d.baseR + proximity * 3;
        const alpha = 0.15 + proximity * 0.65;

        ctx.beginPath();
        ctx.arc(d.x, d.y, r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${tokens.dot}, ${alpha})`;
        ctx.fill();

        if (proximity > 0.05) {
          ctx.beginPath();
          ctx.moveTo(d.x, d.y);
          ctx.lineTo(mx, my);
          ctx.strokeStyle = `rgba(${tokens.dot}, ${proximity * 0.25})`;
          ctx.lineWidth = 1;
          ctx.stroke();
        }
      }
      rafRef.current = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      window.removeEventListener("resize", resize);
      container.removeEventListener("mousemove", handleMove);
      container.removeEventListener("mouseleave", handleLeave);
      cancelAnimationFrame(rafRef.current);
    };
  }, [tokens.dot]);

  // ---------- Draggable department boxes ----------
  const onDragStart = useCallback((e, deptId) => {
    e.preventDefault();
    const startX = e.clientX;
    const startY = e.clientY;
    const startPos = positions[deptId];
    dragState.current = { deptId, startX, startY, startPos };

    const onMove = (ev) => {
      if (!dragState.current) return;
      const { deptId, startX, startY, startPos } = dragState.current;
      const dx = ev.clientX - startX;
      const dy = ev.clientY - startY;
      setPositions((prev) => ({
        ...prev,
        [deptId]: { x: startPos.x + dx, y: startPos.y + dy },
      }));
    };
    const onUp = () => {
      dragState.current = null;
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  }, [positions]);

  const BOX_W = 260;

  return (
    <div
      ref={containerRef}
      className="relative w-full rounded-xl overflow-hidden"
      style={{ backgroundColor: tokens.bgCanvas, border: `1px solid ${tokens.border}`, minHeight: "920px" }}
    >
      <canvas ref={canvasRef} className="absolute inset-0 pointer-events-none" />

      {/* ===== Top toolbar: car on left, logo center, steering wheel right ===== */}
      <div
        className="absolute top-0 left-0 right-0 flex items-center justify-between px-6 py-3"
        style={{ zIndex: 5, backgroundColor: `${tokens.bgSurface}CC`, borderBottom: `1px solid ${tokens.border}`, backdropFilter: "blur(6px)" }}
      >
        {/* Car GIF (Left side) */}
        <div className="flex items-center justify-center select-none" style={{ height: 68 }}>
          <img
            src={carMovingGif}
            alt="Moving Car"
            className="h-[68px] w-auto object-contain pointer-events-none"
          />
        </div>

        {/* Logo */}
        <div
          className="flex items-center justify-center px-5 py-2 rounded-lg font-bold text-sm tracking-wider"
          style={{ backgroundColor: tokens.textHi, color: tokens.bgSurface }}
        >
          <img src={wowcarzLogo} width="100" height="40" alt="Logo" className="mr-2" />
        </div>

        {/* Steering wheel (Right side) */}
        <div
          onMouseDown={handleWheelMouseDown}
          className="relative cursor-grab active:cursor-grabbing select-none"
          style={{ width: 64, height: 64 }}
          title="Drag to steer the org chart"
        >
          <svg
            viewBox="0 0 100 100"
            width="64"
            height="64"
            style={{ transform: `rotate(${wheelAngle}deg)`, transition: wheelDragRef.current ? "none" : "transform 120ms ease-out" }}
          >
            <circle cx="50" cy="50" r="44" fill="none" stroke={tokens.textHi} strokeWidth="8" />
            <circle cx="50" cy="50" r="10" fill={tokens.textHi} />
            <line x1="50" y1="50" x2="50" y2="10" stroke={tokens.textHi} strokeWidth="6" />
            <line x1="50" y1="50" x2="16" y2="70" stroke={tokens.textHi} strokeWidth="6" />
            <line x1="50" y1="50" x2="84" y2="70" stroke={tokens.textHi} strokeWidth="6" />
          </svg>
        </div>
      </div>

      {/* Pannable layer */}
      <div
        className="absolute inset-0"
        style={{ transform: `translate(${pan.x}px, ${pan.y}px)`, transition: wheelDragRef.current ? "none" : "transform 80ms linear" }}
      >
        {/* SVG layer for dynamic connecting lines and arrowheads */}
        <svg className="absolute inset-0 pointer-events-none w-full h-full" style={{ zIndex: 1, minWidth: "1600px", minHeight: "1200px" }}>
          <defs>
            {DEPARTMENTS.map((dept) => (
              <marker
                key={`arrow-${dept.id}`}
                id={`arrowhead-${dept.id}`}
                viewBox="0 0 10 10"
                refX="6"
                refY="5"
                markerWidth="6"
                markerHeight="6"
                orient="auto-start-reverse"
              >
                <path d="M 0 1.5 L 8 5 L 0 8.5 z" fill={dept.color} />
              </marker>
            ))}
          </defs>

          {DEPARTMENTS.map((dept) => {
            const pos = positions[dept.id];
            const originX = 600; // Center coordinate below the Founders row
            const originY = 220;
            const targetX = pos.x + BOX_W / 2;
            const targetY = pos.y;

            return (
              <line
                key={dept.id}
                x1={originX}
                y1={originY}
                x2={targetX}
                y2={targetY}
                stroke={dept.color}
                strokeWidth="2.5"
                strokeDasharray="5 3"
                markerEnd={`url(#arrowhead-${dept.id})`}
                opacity="0.8"
              />
            );
          })}
        </svg>

        {/* Founders row */}
        <div className="absolute flex gap-6" style={{ top: 96, left: "50%", transform: "translateX(-50%)", zIndex: 2 }}>
          {FOUNDERS.map((f) => (
            <div
              key={f.id}
              className="flex flex-col items-center gap-2 px-5 py-4 rounded-xl shadow-lg transition-transform hover:-translate-y-1"
              style={{ backgroundColor: tokens.bgSurface, border: `2px solid ${tokens.textHi}` }}
            >
              <MemberAvatar member={f} size={56} revealed onHover={() => {}} onClick={() => setModalMember(f)} />
              <div className="text-center">
                <div className="text-sm font-bold" style={{ color: tokens.textHi }}>{f.name}</div>
                <div className="text-[11px]" style={{ color: tokens.textMid }}>{f.role}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Department boxes */}
        {DEPARTMENTS.map((dept) => {
          const pos = positions[dept.id];
          return (
            <div
              key={dept.id}
              className="absolute rounded-xl shadow-md transition-shadow hover:shadow-lg"
              style={{
                left: pos.x,
                top: pos.y,
                width: BOX_W,
                zIndex: 2,
                backgroundColor: tokens.bgSurface,
                border: `1px solid ${tokens.border}`,
                borderTop: `4px solid ${dept.color}`,
              }}
            >
              {/* Drag handle & Expand Modal Action */}
              <div
                onMouseDown={(e) => onDragStart(e, dept.id)}
                className="flex items-center justify-between px-3 py-2 cursor-grab active:cursor-grabbing rounded-t-lg"
                style={{ backgroundColor: `${dept.color}15` }}
                title="Drag box to reposition"
              >
                <div className="flex items-center gap-1.5">
                  <span className="text-xs font-bold" style={{ color: dept.color }}>{dept.name}</span>
                  <span className="text-[10px] px-1.5 py-0.5 rounded-full font-medium" style={{ backgroundColor: `${dept.color}25`, color: dept.color }}>
                    {dept.members.length + 1}
                  </span>
                </div>

                <div className="flex items-center gap-1.5">
                  {/* Expand icon button */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedDept(dept);
                    }}
                    className="p-1 rounded-md hover:bg-black/10 dark:hover:bg-white/10 transition-colors cursor-pointer"
                    title={`View ${dept.name} Department Details`}
                  >
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke={dept.color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="15 3 21 3 21 9" />
                      <polyline points="9 21 3 21 3 15" />
                      <line x1="21" y1="3" x2="14" y2="10" />
                      <line x1="3" y1="21" x2="10" y2="14" />
                    </svg>
                  </button>

                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke={dept.color} strokeWidth="2.2" opacity="0.75">
                    <polyline points="5 9 2 12 5 15" />
                    <polyline points="9 5 12 2 15 5" />
                    <polyline points="15 19 12 22 9 19" />
                    <polyline points="19 9 22 12 19 15" />
                    <line x1="2" y1="12" x2="22" y2="12" />
                    <line x1="12" y1="2" x2="12" y2="22" />
                  </svg>
                </div>
              </div>

              {/* Lead */}
              <div className="flex items-center gap-2 px-3 py-2.5 border-b" style={{ borderColor: tokens.border }}>
                <MemberAvatar
                  member={dept.lead}
                  size={34}
                  revealed={hoveredMember === `${dept.id}-lead`}
                  onHover={(v) => setHoveredMember(v ? `${dept.id}-lead` : null)}
                  onClick={() => setModalMember(dept.lead)}
                />
                <div>
                  <div className="text-[11px] font-semibold" style={{ color: tokens.textHi }}>{dept.lead.name}</div>
                  <div className="text-[10px]" style={{ color: tokens.textMid }}>{dept.lead.role}</div>
                </div>
              </div>

              {/* Members */}
              <div className="p-2 space-y-1.5">
                {dept.members.map((m, i) => {
                  const key = `${dept.id}-${i}`;
                  return (
                    <div key={key} className="flex items-center gap-2 px-1.5 py-1 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 transition-colors">
                      <MemberAvatar
                        member={m}
                        size={26}
                        revealed={hoveredMember === key}
                        onHover={(v) => setHoveredMember(v ? key : null)}
                        onClick={() => setModalMember(m)}
                      />
                      <div>
                        <div className="text-[10.5px] font-medium" style={{ color: tokens.textHi }}>{m.name}</div>
                        <div className="text-[9.5px]" style={{ color: tokens.textMid }}>{m.role}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      {/* Individual Member Modal */}
      {modalMember && createPortal(
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4 backdrop-blur-sm animate-in fade-in duration-200"
          style={{ backgroundColor: "rgba(0,0,0,0.65)" }}
          onClick={() => setModalMember(null)}
        >
          <div
            className="flex flex-col items-center gap-3 p-6 rounded-2xl shadow-2xl animate-in zoom-in-95 duration-200 w-80 text-center"
            style={{ backgroundColor: tokens.bgSurface, border: `1px solid ${tokens.border}` }}
            onClick={(e) => e.stopPropagation()}
          >
            <img src={modalMember.avatar} alt={modalMember.name} className="w-36 h-36 rounded-xl object-cover shadow-sm" />
            <div>
              <div className="text-base font-bold" style={{ color: tokens.textHi }}>{modalMember.name}</div>
              <div className="text-xs font-medium mt-0.5" style={{ color: tokens.textMid }}>{modalMember.role}</div>
              {modalMember.email && <div className="text-[11px] mt-1 text-blue-500 font-mono">{modalMember.email}</div>}
              {modalMember.experience && <div className="text-[11px] mt-0.5" style={{ color: tokens.textMid }}>Experience: {modalMember.experience}</div>}
            </div>
            <button
              onClick={() => setModalMember(null)}
              className="mt-2 px-5 py-1.5 rounded-lg text-xs font-semibold text-white cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: "#2563EB" }}
            >
              Close
            </button>
          </div>
        </div>,
        document.body
      )}

      {/* Full Department Details Modal */}
      {selectedDept && createPortal(
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4 backdrop-blur-md animate-in fade-in duration-200"
          style={{ backgroundColor: "rgba(0,0,0,0.65)" }}
          onClick={() => setSelectedDept(null)}
        >
          <div
            className="flex flex-col max-h-[85vh] w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200"
            style={{ backgroundColor: tokens.bgSurface, border: `1px solid ${tokens.border}` }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b" style={{ borderColor: tokens.border, borderTop: `5px solid ${selectedDept.color}` }}>
              <div className="flex items-center gap-3">
                <div className="w-3.5 h-3.5 rounded-full" style={{ backgroundColor: selectedDept.color }} />
                <div>
                  <h3 className="text-lg font-bold" style={{ color: tokens.textHi }}>{selectedDept.name} Department</h3>
                  <p className="text-xs" style={{ color: tokens.textMid }}>Total Team Size: {selectedDept.members.length + 1} Employees</p>
                </div>
              </div>
              <button
                onClick={() => setSelectedDept(null)}
                className="p-1.5 rounded-lg hover:bg-black/10 dark:hover:bg-white/10 text-lg font-bold leading-none cursor-pointer"
                style={{ color: tokens.textMid }}
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 overflow-y-auto space-y-6">
              {/* Department Overview */}
              <div>
                <h4 className="text-xs font-bold uppercase tracking-wider mb-1.5" style={{ color: selectedDept.color }}>Overview</h4>
                <p className="text-sm leading-relaxed" style={{ color: tokens.textMid }}>{selectedDept.description}</p>
              </div>

              {/* Department Head */}
              <div>
                <h4 className="text-xs font-bold uppercase tracking-wider mb-2.5" style={{ color: selectedDept.color }}>Department Lead / Head</h4>
                <div
                  className="flex items-center justify-between p-3.5 rounded-xl"
                  style={{ backgroundColor: `${selectedDept.color}10`, border: `1px solid ${selectedDept.color}30` }}
                >
                  <div className="flex items-center gap-3.5">
                    <img src={selectedDept.lead.avatar} alt={selectedDept.lead.name} className="w-12 h-12 rounded-full border-2" style={{ borderColor: selectedDept.color }} />
                    <div>
                      <div className="text-sm font-bold" style={{ color: tokens.textHi }}>{selectedDept.lead.name}</div>
                      <div className="text-xs font-medium" style={{ color: selectedDept.color }}>{selectedDept.lead.role}</div>
                      <div className="text-[11px] font-mono mt-0.5" style={{ color: tokens.textMid }}>{selectedDept.lead.email}</div>
                    </div>
                  </div>
                  <span className="text-xs px-2.5 py-1 rounded-full font-medium" style={{ backgroundColor: `${selectedDept.color}20`, color: selectedDept.color }}>
                    Exp: {selectedDept.lead.experience}
                  </span>
                </div>
              </div>

              {/* Team Members List */}
              <div>
                <h4 className="text-xs font-bold uppercase tracking-wider mb-2.5" style={{ color: selectedDept.color }}>
                  Team Members ({selectedDept.members.length})
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {selectedDept.members.map((m, idx) => (
                    <div
                      key={idx}
                      className="flex items-center justify-between p-3 rounded-xl hover:bg-black/5 dark:hover:bg-white/5 transition-colors border"
                      style={{ borderColor: tokens.border, backgroundColor: tokens.bgCanvas }}
                    >
                      <div className="flex items-center gap-3">
                        <img src={m.avatar} alt={m.name} className="w-10 h-10 rounded-full" />
                        <div>
                          <div className="text-xs font-bold" style={{ color: tokens.textHi }}>{m.name}</div>
                          <div className="text-[11px]" style={{ color: tokens.textMid }}>{m.role}</div>
                          <div className="text-[10px] font-mono text-blue-500">{m.email}</div>
                        </div>
                      </div>
                      <span className="text-[10px] px-2 py-0.5 rounded font-medium" style={{ backgroundColor: tokens.border, color: tokens.textMid }}>
                        {m.experience}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="flex justify-end px-6 py-3 border-t" style={{ borderColor: tokens.border, backgroundColor: tokens.bgCanvas }}>
              <button
                onClick={() => setSelectedDept(null)}
                className="px-4 py-1.5 rounded-lg text-xs font-semibold text-white cursor-pointer hover:opacity-90 transition-opacity"
                style={{ backgroundColor: selectedDept.color }}
              >
                Done
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}

function MemberAvatar({ member, size, revealed, onHover, onClick }) {
  return (
    <div
      className="relative rounded-full overflow-hidden cursor-pointer flex-shrink-0"
      style={{ width: size, height: size }}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
      onClick={onClick}
    >
      <img
        src={member.avatar}
        alt={member.name}
        className="w-full h-full object-cover transition-all duration-300"
        style={{ filter: revealed ? "blur(0px)" : "blur(6px)", transform: revealed ? "scale(1)" : "scale(1.15)" }}
      />
    </div>
  );
}